<script>
import HolidayWarning from "@/components/_Shared/Warnings/Holiday";
import { swiper, swiperSlide } from "vue-awesome-swiper";

import "swiper/dist/css/swiper.css";

import moment from "@/utils/moment";
import dateMixin from "@/mixins/dateMixin";
import timeMixin from "@/mixins/timeMixin";
export default {
  mixins: [dateMixin, timeMixin],

  components: {
    swiper,
    swiperSlide,
    HolidayWarning
  },

  props: {
    professional: {
      type: Object,
      required: true
    },
    selectedEvent: {
      type: Object,
      required: false
    }
  },

  data() {
    return {
      swiperOption: {
        slidesPerView: 3,
        slidesPerColumn: 3,
        normalizeSlideIndex: false,
        centerInsufficientSlides: true,
        slidesPerColumnFill: "row",
        grabCursor: true,
        slidesPerGroup: 3,
        spaceBetween: 0,
        navigation: {
          nextEl: ".next",
          prevEl: ".prev"
        },
        breakpoints: {
          630: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            slidesPerGroup: 1
          },
          730: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            slidesPerGroup: 2
          }
        }
      }
    };
  },

  methods: {
    dayIsChristmasEve() {
      return this.selectedEvent
        ? moment(this.selectedEvent.starts_at).format("MM-DD") === "12-24"
        : false;
    }
  },

  computed: {
    day() {
      return this.selectedEvent ? moment(this.selectedEvent.starts_at) : false;
    }
  }
};
</script>

<template>
  <div class="section">
    <div class="section-title mt-20">
      ESTE SÃO OS HORÁRIOS DISPONÍVEIS COM {{professional.account.first_name}}
      <hr />
    </div>

    <swiper :options="swiperOption">
      <swiper-slide
        v-for="(event, index) in professional.account.schedule.events"
        :key="index+'-event'"
      >
        <div
          class="event"
          @click="$emit('eventSelected', event)"
          :class="{selected: selectedEvent === event}"
        >
          <b class="text-purple">{{event.starts_at | formatDate('DD/MM')}}</b>
          <b>
            <small class="text-purple">{{event.starts_at | formatDate('dddd')}}</small>
          </b>
          <small>
            das
            {{event.starts_at | formatDate('HH[hrs]')}}
            às
            {{event.ends_at | formatDate('HH[hrs]')}}
          </small>
        </div>
      </swiper-slide>

      <div class="swiper-button-prev prev" slot="button-prev"></div>
      <div class="swiper-button-next next" slot="button-next"></div>
    </swiper>

    <small class="warning" v-if="dayIsChristmasEve()">
      <b>Você escolheu o dia 24/12</b>, caso o profissional autônomo escolhido tenha algum imprevisto pessoal e precise
      <b>cancelar a limpeza</b>, é possível que a limpeza precise ser
      <b>reagendada para após o dia 25/12/2019</b>
    </small>

    <holiday-warning v-if="day" :day="day" style="max-width: 450px; text-align: center;" />
  </div>
</template>

<style scoped>
.warning {
  max-width: 450px;
  color: var(--pink);
  text-align: center;
  margin-bottom: 10px;
}
.section {
  max-width: 600px;
}
.row {
  justify-content: center;
}

.swiper-container {
  width: 100%;
  text-align: center;
}

.event {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  border: 2px solid #eee;
  border-radius: 4px;
  margin: 10px;
  font-size: 14px;
  cursor: pointer;
  user-select: none;
}

.event.selected {
  border-color: var(--purple);
}

.swiper-button-prev {
  background-image: url("/static/arrow-prev.svg") !important;
}

.swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  left: 0 !important;
}

.swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  right: 0 !important;
}

.swiper-button-prev.swiper-button-disabled,
.swiper-button-next.swiper-button-disabled {
  display: none;
}

.swiper-button-next {
  background-image: url("/static/arrow-next.svg") !important;
}

@media (max-width: 720px) {
  .section {
    width: 400px;
  }

  .swiper-container {
    padding: 0 20px;
    width: calc(100% - 40px) !important;
  }
}

@media (max-width: 630px) {
  .section {
    width: 250px;
  }
  .event {
    width: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/Steps/AvailableEvents.vue